<template>
  <div
    class="inspiration-tabs"
    :class="{'inspiration-tabs--sticky': showStickyTab && stickyState}"
  >
    <slot name="tabs" />
    <slot
      v-if="showStickyTab"
      name="sticky-tab"
    />
  </div>
</template>

<script lang="ts">
  import {Vue, Options, Prop} from 'vue-property-decorator';
  import {throttle} from '../../utilities/js/throttle/throttle';
  import {usePlaceholder} from '../../utilities/vueMixins/placeholderMixin/placeholder';

  @Options({
    name: 'inspiration-tabs',
  })
  export default class InspirationTabs extends Vue {
    @Prop({default: 0})
    readonly offsetBasis: number;

    @Prop({default: 100})
    readonly elementHeight: number; // Height of component

    @Prop({default: false})
    readonly showStickyTab: boolean;

    stickyState: boolean = false;

    mounted() {
      window.addEventListener('scroll', throttle(this.onScroll, 150));
      usePlaceholder('inspiration-tabs');
    }

    onScroll() {
      this.stickyState = Math.floor(this.$el.getBoundingClientRect().top - this.offsetBasis) <= 0;
    }
  }
</script>
